/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createEntity = /* GraphQL */ `mutation CreateEntity($siteId: String!, $input: CreateEntityInput!) {
  createEntity(siteId: $siteId, input: $input) {
    success
    message
    entity {
      ... on SUCCESS {
        id
        detail
        type
        shift
        department
        photo
        owner
        date
      }
      ... on SAFETY {
        id
        detail
        type
        shift
        department
        photo
        date
        ecd
        owner
      }
      ... on BARRIER {
        id
        detail
        type
        shift
        department
        photo
        owner
        process
        date
        ecd
        category
        modifyDate
        updateDetail
        progress
        priority
      }
      ... on PROJECT {
        id
        detail
        type
        shift
        department
        photo
        owner
        innovator
        process
        date
        ecd
        modifyDate
        updateDetail
        progress
        priority
      }
    }
    siteId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEntityMutationVariables,
  APITypes.CreateEntityMutation
>;
export const updateEntity = /* GraphQL */ `mutation UpdateEntity(
  $siteId: String!
  $id: ID!
  $type: EntityType!
  $input: UpdateEntityInput!
) {
  updateEntity(siteId: $siteId, id: $id, type: $type, input: $input) {
    success
    message
    entity {
      ... on SUCCESS {
        id
        detail
        type
        shift
        department
        photo
        owner
        date
      }
      ... on SAFETY {
        id
        detail
        type
        shift
        department
        photo
        date
        ecd
        owner
      }
      ... on BARRIER {
        id
        detail
        type
        shift
        department
        photo
        owner
        process
        date
        ecd
        category
        modifyDate
        updateDetail
        progress
        priority
      }
      ... on PROJECT {
        id
        detail
        type
        shift
        department
        photo
        owner
        innovator
        process
        date
        ecd
        modifyDate
        updateDetail
        progress
        priority
      }
    }
    siteId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEntityMutationVariables,
  APITypes.UpdateEntityMutation
>;
export const deleteEntity = /* GraphQL */ `mutation DeleteEntity($siteId: String!, $type: String!, $id: ID!) {
  deleteEntity(siteId: $siteId, type: $type, id: $id) {
    success
    message
    siteId
    type
    id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEntityMutationVariables,
  APITypes.DeleteEntityMutation
>;
